import './Samples.scss';
import Component from './Samples.js';
export default Component;
